import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteOriginTemplateFromTeam = {
  name: "deleteOriginTemplateFromTeam" as const,
  input: z.object({ originTemplateId: zExt.objectId() }),
  output: z.object({ success: z.boolean(), message: z.string().optional() }),
};
